import { render, staticRenderFns } from "./TaskDetailModal.vue?vue&type=template&id=24ed67ea&"
import script from "./TaskDetailModal.vue?vue&type=script&lang=js&"
export * from "./TaskDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports